<div class="admin-page container-fluid py-4">

  <!-- Header -->
  <div class="page-header mb-4">
    <div>
      <h2><i class="bi bi-shield-lock me-2 text-danger"></i>Administração do Sistema</h2>
      <p class="text-muted mb-0">Gerencie usuários, assinaturas e pagamentos da plataforma</p>
    </div>
  </div>

  <!-- Abas de navegação -->
  <ul class="nav nav-tabs mb-4">
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'dashboard'" (click)="setActiveTab('dashboard')">
        <i class="bi bi-speedometer2 me-1"></i> Dashboard
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'users'" (click)="setActiveTab('users')">
        <i class="bi bi-people me-1"></i> Usuários
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'professionals'" (click)="setActiveTab('professionals')">
        <i class="bi bi-person-badge me-1"></i> Profissionais
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link" [class.active]="activeTab === 'subscriptions'" (click)="setActiveTab('subscriptions')">
        <i class="bi bi-calendar-check me-1"></i> Assinaturas
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link position-relative" [class.active]="activeTab === 'payments'" (click)="setActiveTab('payments')">
        <i class="bi bi-cash-coin me-1"></i> Pagamentos
        <span class="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill"
              *ngIf="pendingPayments.length > 0">
          {{ pendingPayments.length }}
        </span>
      </button>
    </li>
  </ul>

  <!-- Loading -->
  <div class="text-center py-5" *ngIf="loading">
    <div class="spinner-border text-primary"></div>
  </div>

  <!-- ===================== ABA: DASHBOARD ===================== -->
  <div *ngIf="activeTab === 'dashboard' && !loading">
    <div class="row g-3 mb-4" *ngIf="dashboardStats">
      <div class="col-sm-6 col-xl-3">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <p class="text-muted small mb-1">Usuários</p>
                <h3 class="mb-0">{{ dashboardStats.totalUsers }}</h3>
              </div>
              <i class="bi bi-people fs-2 text-primary opacity-50"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-3">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <p class="text-muted small mb-1">Assinaturas Ativas</p>
                <h3 class="mb-0 text-success">{{ dashboardStats.activeSubscriptions }}</h3>
              </div>
              <i class="bi bi-check-circle fs-2 text-success opacity-50"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-3">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <p class="text-muted small mb-1">Pagamentos Pendentes</p>
                <h3 class="mb-0 text-warning">{{ dashboardStats.pendingPayments }}</h3>
              </div>
              <i class="bi bi-clock-history fs-2 text-warning opacity-50"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-3">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <p class="text-muted small mb-1">Receita do Mês</p>
                <h3 class="mb-0 text-success">{{ formatCurrency(dashboardStats.monthlyRevenue) }}</h3>
              </div>
              <i class="bi bi-graph-up fs-2 text-success opacity-50"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-3">
      <div class="col-md-4">
        <div class="card border-0 shadow-sm text-center py-3">
          <div class="card-body">
            <p class="text-muted small mb-1">Trial</p>
            <h4 class="text-info">{{ dashboardStats?.trialSubscriptions ?? 0 }}</h4>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card border-0 shadow-sm text-center py-3">
          <div class="card-body">
            <p class="text-muted small mb-1">Atrasados / Suspensos</p>
            <h4 class="text-danger">{{ dashboardStats?.expiredSubscriptions ?? 0 }}</h4>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card border-0 shadow-sm text-center py-3">
          <div class="card-body">
            <p class="text-muted small mb-1">Receita Total</p>
            <h4 class="text-success">{{ formatCurrency(dashboardStats?.totalRevenue ?? 0) }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================== ABA: USUÁRIOS ===================== -->
  <div *ngIf="activeTab === 'users' && !loading">
    <div class="mb-3">
      <input type="text" class="form-control" placeholder="Buscar por nome ou e-mail..."
             [(ngModel)]="userSearchTerm" (input)="filterUsers()">
    </div>
    <div class="table-responsive">
      <table class="table table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th>Nome</th><th>E-mail</th><th>Admin</th><th>Status</th><th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of filteredUsers">
            <td><strong>{{ u.name }}</strong></td>
            <td>{{ u.email }}</td>
            <td>
              <span class="badge" [class.bg-danger]="u.isAdmin" [class.bg-secondary]="!u.isAdmin">
                {{ u.isAdmin ? 'Admin' : 'Usuário' }}
              </span>
            </td>
            <td>
              <span class="badge" [class.bg-success]="u.isActive" [class.bg-secondary]="!u.isActive">
                {{ u.isActive ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td class="text-end">
              <button class="btn btn-sm btn-outline-secondary me-1" (click)="viewUserDetails(u)" title="Detalhes">
                <i class="bi bi-eye"></i>
              </button>
              <button class="btn btn-sm"
                      [class.btn-outline-danger]="u.isActive"
                      [class.btn-outline-success]="!u.isActive"
                      (click)="toggleUserStatus(u)">
                <i class="bi" [class.bi-person-slash]="u.isActive" [class.bi-person-check]="!u.isActive"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="filteredUsers.length === 0">
            <td colspan="5" class="text-center text-muted py-4">Nenhum usuário encontrado</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ===================== ABA: PROFISSIONAIS ===================== -->
  <div *ngIf="activeTab === 'professionals' && !loading">
    <div class="mb-3">
      <input type="text" class="form-control" placeholder="Buscar por nome ou especialidade..."
             [(ngModel)]="professionalSearchTerm" (input)="filterProfessionals()">
    </div>
    <div class="table-responsive">
      <table class="table table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th>Nome</th><th>Especialidade</th><th>E-mail</th><th>Status</th><th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of filteredProfessionals">
            <td><strong>{{ p.name }}</strong></td>
            <td>{{ p.specialty || '—' }}</td>
            <td>{{ p.email || '—' }}</td>
            <td>
              <span class="badge" [class.bg-success]="p.isActive" [class.bg-secondary]="!p.isActive">
                {{ p.isActive ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td class="text-end">
              <button class="btn btn-sm"
                      [class.btn-outline-danger]="p.isActive"
                      [class.btn-outline-success]="!p.isActive"
                      (click)="toggleProfessionalStatus(p)">
                <i class="bi" [class.bi-toggle-on]="p.isActive" [class.bi-toggle-off]="!p.isActive"></i>
                {{ p.isActive ? 'Desativar' : 'Ativar' }}
              </button>
            </td>
          </tr>
          <tr *ngIf="filteredProfessionals.length === 0">
            <td colspan="5" class="text-center text-muted py-4">Nenhum profissional encontrado</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ===================== ABA: ASSINATURAS ===================== -->
  <div *ngIf="activeTab === 'subscriptions' && !loading">
    <div class="d-flex gap-2 mb-3 flex-wrap">
      <button class="btn btn-sm" [class.btn-secondary]="subscriptionFilter === null"
              [class.btn-outline-secondary]="subscriptionFilter !== null" (click)="loadSubscriptions()">
        Todas
      </button>
      <button class="btn btn-sm" [class.btn-info]="subscriptionFilter === 1"
              [class.btn-outline-info]="subscriptionFilter !== 1" (click)="loadSubscriptions(1)">
        Trial
      </button>
      <button class="btn btn-sm" [class.btn-success]="subscriptionFilter === 2"
              [class.btn-outline-success]="subscriptionFilter !== 2" (click)="loadSubscriptions(2)">
        Ativas
      </button>
      <button class="btn btn-sm" [class.btn-warning]="subscriptionFilter === 3"
              [class.btn-outline-warning]="subscriptionFilter !== 3" (click)="loadSubscriptions(3)">
        Atrasadas
      </button>
      <button class="btn btn-sm" [class.btn-danger]="subscriptionFilter === 4"
              [class.btn-outline-danger]="subscriptionFilter !== 4" (click)="loadSubscriptions(4)">
        Suspensas
      </button>
    </div>
    <div class="table-responsive">
      <table class="table table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th>Profissional</th><th>Status</th><th>Trial até</th>
            <th>Próx. Cobrança</th><th>Mensalidade</th><th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of subscriptions">
            <td><strong>{{ s.professionalName }}</strong></td>
            <td>
              <span class="badge"
                    [class.bg-info]="s.status === 1"
                    [class.bg-success]="s.status === 2"
                    [class.bg-warning]="s.status === 3"
                    [class.bg-danger]="s.status >= 4">
                {{ getStatusLabel(s.status) }}
              </span>
            </td>
            <td>{{ s.trialEndDate ? formatDate(s.trialEndDate) : '—' }}</td>
            <td>{{ s.nextBillingDate ? formatDate(s.nextBillingDate) : '—' }}</td>
            <td>{{ formatCurrency(s.monthlyAmount) }}</td>
            <td class="text-end">
              <button class="btn btn-sm btn-outline-success me-1"
                      *ngIf="s.status !== 2" (click)="activateSubscription(s)">
                <i class="bi bi-check-circle"></i> Ativar
              </button>
              <button class="btn btn-sm btn-outline-danger"
                      *ngIf="s.status !== 5" (click)="cancelSubscription(s)">
                <i class="bi bi-x-circle"></i> Cancelar
              </button>
            </td>
          </tr>
          <tr *ngIf="subscriptions.length === 0">
            <td colspan="6" class="text-center text-muted py-4">Nenhuma assinatura encontrada</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ===================== ABA: PAGAMENTOS ===================== -->
  <div *ngIf="activeTab === 'payments' && !loading">

    <div class="alert alert-info d-flex align-items-center gap-2" *ngIf="pendingPayments.length === 0">
      <i class="bi bi-check-circle-fill fs-5"></i>
      <span>Nenhum pagamento pendente no momento.</span>
    </div>

    <div class="table-responsive" *ngIf="pendingPayments.length > 0">
      <table class="table table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th>#</th>
            <th>Profissional</th>
            <th>E-mail</th>
            <th>Valor</th>
            <th>Vencimento</th>
            <th>Chave PIX</th>
            <th>Referência</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of pendingPayments"
              [class.table-warning]="isVencido(p.dueDate)">
            <td class="text-muted small">{{ p.id }}</td>
            <td><strong>{{ p.professionalName }}</strong></td>
            <td>{{ p.professionalEmail || '—' }}</td>
            <td><strong class="text-success">{{ formatCurrency(p.amount) }}</strong></td>
            <td>
              {{ formatDate(p.dueDate) }}
              <span class="badge bg-danger ms-1" *ngIf="isVencido(p.dueDate)">Vencido</span>
            </td>
            <td>
              <code class="small">{{ p.pixKey || '—' }}</code>
            </td>
            <td class="small text-muted">{{ p.notes || '—' }}</td>
            <td class="text-end">
              <button class="btn btn-sm btn-success" (click)="confirmPayment(p)">
                <i class="bi bi-check-lg me-1"></i> Confirmar Pagamento
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

</div>

<!-- Modal detalhes do usuário -->
<div class="modal-overlay" *ngIf="showUserDetailsModal" (click)="closeModals()"></div>
<div class="modal-wrap" *ngIf="showUserDetailsModal">
  <div class="modal-box" style="max-width:480px">
    <div class="modal-box-header">
      <h5 class="mb-0">Detalhes do Usuário</h5>
      <button class="btn-x" (click)="closeModals()">✕</button>
    </div>
    <div class="modal-box-body" *ngIf="selectedUser">
      <p><strong>Nome:</strong> {{ selectedUser.name }}</p>
      <p><strong>E-mail:</strong> {{ selectedUser.email }}</p>
      <p><strong>Telefone:</strong> {{ selectedUser.phone || '—' }}</p>
      <p><strong>Admin:</strong> {{ selectedUser.isAdmin ? 'Sim' : 'Não' }}</p>
      <p><strong>Status:</strong> {{ selectedUser.isActive ? 'Ativo' : 'Inativo' }}</p>
      <p><strong>Cadastro:</strong> {{ formatDate(selectedUser.createdAt) }}</p>
    </div>
  </div>
</div>
